import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { getCookie } from '../../../common/utils/api_utils';

export const tokenSchema = Yup.object({
  token: Yup.string().required('Token is required'),
});

export const linkSchema = Yup.object({
  figmaLink: Yup.string().url('Invalid URL').required('Figma link is required'),
});

export const handleSubmitSelection = async (
  setSelectedImage,
  selectedImages,
  projectId,
  version,
  history,
  systemRoles,
  setLoading,
  userPrompt,
  roles,
  generateFigmaLayouts,
) => {
  setSelectedImage('');
  try {
    setLoading(true);
    const aiModel = process.env.REACT_APP_AI_MODEL;
    const apiKey = process.env.REACT_APP_API_KEY;
    const args = {
      figmaImageUrl: selectedImages,
      aiModel,
      apiKey,
      projectId,
      projectVersion: version,
      token: getCookie('token'),
      userIp: getCookie('userIp'),
      systemRoles,
    };
    const responseImageCode = await generateFigmaLayouts(args);
    if (responseImageCode.status === 200) {
      toast.success(responseImageCode.data.message);
      setLoading(false);
      setTimeout(() => {
        history.push({
          pathname: `/ai-prompt-builder/${version}/v/${projectId}/prompt-pages-list`,
          state: { userPrompt, roles: roles },
        });
      }, 1000);
    }
  } catch (error) {
    setLoading(false);
    toast.error('Something went wrong while generating the layout.');
  }
};

export const openModal = (imageData, setCurrentImage, setShowModal) => {
  setCurrentImage(imageData);
  setShowModal(true);
};

export const closeModal = (setShowModal, setCurrentImage) => {
  setShowModal(false);
  setCurrentImage(null);
};

export const handleLinkSubmit = async ({
  values,
  setLoading,
  setFigmaLink,
  setFigmaImageData,
  projectId,
  version,
  setIsExpired,
  clearSessionStorage,
  fetchFigmaImage,
}) => {
  try {
    setLoading(true);
    const { figmaLink } = values;
    setFigmaLink(figmaLink);
    sessionStorage.setItem('figmaLink', figmaLink);
    sessionStorage.removeItem('figmaImageData');
    setFigmaImageData([]);
    const response = await fetchFigmaImage({ projectId, figmaLink, version });
    sessionStorage.setItem('figmaImageData', JSON.stringify(response.data));
    setFigmaImageData(response.data);
  } catch (error) {
    if (error.status === 403) {
      toast.error(error.response.data.message);
      clearSessionStorage(setFigmaLink);
      setIsExpired(true);
    } else if (error.status === 404) {
      toast.error(error.response.data.message);
    } else if (error.status === 400) {
      toast.error(error.response.data.message);
    } else {
      toast.error('Please try Again');
    }
  } finally {
    setLoading(false);
  }
};

export const checkTokenStatus = async (
  setIsExpired,
  setFigmaImageData,
  clearSessionStorage,
  setFigmaLink,
  fetchFigmaData,
  projectId,
  version,
) => {
  try {
    const response = await fetchFigmaData({ projectId, version });
    const { data } = response;
    setIsExpired(data.isExpired);
    const storedImages = sessionStorage.getItem('figmaImageData');
    if (storedImages) {
      setFigmaImageData(JSON.parse(storedImages));
    }
  } catch (error) {
    clearSessionStorage(setFigmaLink);
    console.error('Error fetching Figma data:', error);
  }
};

export const handleTokenSubmit = async ({
  values,
  setLoading,
  setIsExpired,
  setFigmaLink,
  figmaTokenSubmit,
  clearSessionStorage,
  projectId,
  version,
}) => {
  const { token } = values;
  setLoading(true);
  try {
    const saveTokenResponse = await figmaTokenSubmit({ projectId, version, token });
    const { data } = saveTokenResponse;

    if (!data.isExpired) {
      setIsExpired(false);
      sessionStorage.removeItem('figmaLink');
      sessionStorage.removeItem('figmaImageData');
    } else {
      setIsExpired(true);
      sessionStorage.removeItem('figmaLink');
      sessionStorage.removeItem('figmaImageData');
    }
  } catch (error) {
    if (error.status === 403) {
      toast.error(error.response.data.message);
    }
    setIsExpired(true);
    clearSessionStorage(setFigmaLink);
  } finally {
    setLoading(false);
  }
};
